// extracted by mini-css-extract-plugin
export default {"popupHead":"DeletePopup_popupHead__EKFr+","popupButtonDiv":"DeletePopup_popupButtonDiv__ZVd7N"};